import { IRequestParams, IResultContent, request } from "@fanfanlo";
import { tms } from "../tms";
import { IRequestOptions } from "../IRequestOptions";

/**
 * @description 获取联系人类型的请求参数
 */
export interface IEmcGetContactTypesParams extends IRequestParams {
    // 可能不需要额外参数，但保留结构以备将来扩展
}

/**
 * @description 单个联系人类型
 */
export interface IEmcContactTypeItem {
    id: string;
    name: string;
    // 根据实际需要可以添加更多字段，例如 icon, description 等
}

/**
 * @description 获取联系人类型的完整响应体
 */
export interface IEmcGetContactTypesResult extends IResultContent {
    data: {
        types: Array<{
            uuid: string;
            name: string;
            is_system: boolean;
        }>;
    };
}

/**
 * @description 调用获取联系人类型接口的函数
 * @param opts 包含 params, gateway, handler 的请求选项
 */
export async function tmsEmcGetContactTypes(opts: IRequestOptions<IEmcGetContactTypesParams>) {
    const res = await request<IEmcGetContactTypesResult>(tms.TEmc, tms.MEmcGetContactTypes, opts.params, opts.gateway, opts.handler);
    return res;
}
